<template>
  <div>
    <div class="foot">
      <div class="foot_txt">Copyright © 2019-2024 江苏追光智能科技有限公司</div>
      <div class="foot_txt">版权所有 Powered by EyouCms</div>
      <div class="foot_txt">备案号：苏ICP备20027758号-1</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'foot',
  watch: {
    $route: {
      handler: function (val, oldVal) {
        document.documentElement.scrollTop = 0
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.foot {
  padding: 12px 0;
  background: #f3f3f3;
  .foot_txt {
    font-size: 10px;
    line-height: 18px;
    text-align: center;
    color: #000;
  }
}
</style>
